// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3FOxG","boxTitle":"Qualiphy_boxTitle__2zUOa","box":"Qualiphy_box__3IEoR","toggleWrap":"Qualiphy_toggleWrap__1J2T5"};